import React, { useEffect,useRef } from 'react'
import {useRealtimeTimer} from 'src/hooks/useRealtimeTimer'
import ShuffleTypo from 'src/components/atoms/ShuffleTypo'
import styles from 'src/assets/styles/top/styles.module.styl'
import stylesSlider from 'src/assets/styles/top/carousel.module.styl'

const ShuffleText = (props) => {
  const [text, setText] = React.useState(' ')
  const str = props.text
  const delay = props.delay
  let time = 0
  const myRef = useRef(null);
  let st = null
  let intersectTarget = myRef.current

  let isEffect = true
  
  if(window){
    if(!window.is_Effect && !props.isEffect){
      isEffect = false
    }
  }

  const onComplete = ()=>{
    const odm = myRef.current.closest('.'+stylesSlider.odm)
    const modalOdm = myRef.current.closest('.'+stylesSlider.modal_odm)
    if(odm !== null){
      const waits = odm.querySelectorAll('.wait')
      for (let i = 0; i < waits.length; i++) {
        const wait = waits[i];
        wait.classList.add('go')
      }
    }
    if(modalOdm !== null){
      const waits = modalOdm.querySelectorAll('.wait')
      for (let i = 0; i < waits.length; i++) {
        const wait = waits[i];
        wait.classList.add('go')
      }
    }
  }

  useEffect(()=>{
    if(isEffect){
      const speed = (props.speed)?props.speed:1
      st = new ShuffleTypo(myRef.current,str,delay,speed, 'PRE_ROLL_IN', props.rollNum, props.letterDelay)
      intersectTarget = myRef.current
      if(myRef.current.classList.contains('child')){
        intersectTarget = myRef.current.closest('.parent')
      }
    }
  })
  
  useRealtimeTimer(() => {
    if(isEffect){
      if(myRef.current.classList.contains('text_state_pre_roll_in')){
        myRef.current.classList.remove('text_state_pre_roll_in')
        st.state = 'PRE_ROLL_IN'
        for (let i = 0; i < st.letterItems.length; i++) {
          const letter = st.letterItems[i];
          letter.state = 'PRE_ROLL_IN'
        }
        st.reset()
      }

      if(myRef.current.classList.contains('text_state_show')){
        st.state = 'SHOW'
        for (let i = 0; i < st.letterItems.length; i++) {
          const letter = st.letterItems[i];
          letter.state = 'SHOW'
        }
        st.reset()
      }

      if(myRef.current.classList.contains('text_delay_zero')){
        st.delay = -1
      }
      
      if(st.state != 'SHOW'){
        if (intersectTarget.classList.contains('intersectTarget')) {
          if (intersectTarget.classList.contains('intersect')) {
            if (!myRef.current.getAttribute('delay')) {
              st.delay = -1
            }
            st.render(time)
          }
        }else{
          st.render(time)
        }

        let replaced = st.text.replace(/_n/g, '\n')
        replaced = replaced.replace(/_s/g, '\u0020')
        replaced = replaced.replace(/_q/g, '\'')
        myRef.current.textContent = replaced
      }

      if(st.state == 'SHOW' && myRef.current.classList.contains('onComplete')){
        myRef.current.classList.remove('onComplete')
        onComplete()
      }
      time++
    }
  })

  if(isEffect){
    return <span className={styles.shuffle_typo + ' ' + props.className} ref={myRef}>{''}</span>
  }else{
    let replaced = str.replace(/_n/g, '\n')
    replaced = replaced.replace(/_s/g, '\u0020')
    replaced = replaced.replace(/_q/g, '\'')
    return <span className={props.className}>{replaced}</span>
  }
}

// Propsのデフォルト値
ShuffleText.defaultProps = {
  isEffect: true,
};

export default ShuffleText